import { SenseChat } from "../../utils/error";
import {
  EChatRecvStatus,
  EStreamDataType,
  IChatRecvMessage,
  EFileQueryType,
  IChatTransLang,
} from "./types";

export const CHAT_CHANNEL: string = "chat-web"; //	pc通道 = chat-web, 终端通道 = chat-app
// export const CHAT_CHANNEL: string = "test"; //	pc通道 = chat-web, 终端通道 = chat-app

export const CLIENT_CHAN: string = "chatOnCom"; //	chatOnCom基础对话；chatOnVoice 语音通话；chatOnTraceless 无痕对话;
export const CHAT_ON_R1: string = "chatOnR1"; // R1对话
export const CHAT_ON_VIDEO_COM: string = "chatOnVideoCom"; // 视频总结对话
export const CHAT_ON_VIDEO_EDIT: string = "chatOnVideoEdit"; // 视频编辑对话
export const CHAT_MAX_PAGE_SIZE: number = 10000;
export const CHAT_PAGE_SIZE: number = 10;
export enum EChatErrorCode {
  default = -1,
  inputSensitive = SenseChat.Status.I_CONVERSATION_INPUT_SENSETIVE_ERROR, // 输入敏感
  outputSensitive = SenseChat.Status.I_CONVERSATION_OUTPUT_SENSETIVE_ERROR, // 输出敏感
  sessionDeleted = SenseChat.Status.I_SESSION_DELETED_ERROR, // session 被删除
  thinkSensitive = SenseChat.Status.I_CONVERSATION_THINK_SENSETIVE_ERROR, // session 被删除
  // sessionUnable = 170002, // session 不可用
  userBusy = SenseChat.Status.UserBusy, // 用户忙
  modelError = 210000, // 模型错误
  bothSensitive = 180009,
}

// 结束当前输出
export const STREAM_END_MSG: IChatRecvMessage = {
  status: EChatRecvStatus.end,
  type: EStreamDataType.status,
};

// 敏感话术
export enum SensitiveTips {
  hasAIContent = "你好，这个问题我暂时无法回答，让我们换个话题再聊聊吧。", // 敏感时有输出内容
  noAIContent = "我们还是换个话题聊聊吧。搜资讯、读文档、写文案、绘画……我都能帮到你。", // 输入敏感 || (输出敏感 && 无内容)
}

export const FILE_QUERY_MSG: { [pro: string]: string } = {
  [EFileQueryType.summary]: "总结以下内容",
  [EFileQueryType.translation]: "把下面的内容翻译成中文",
  [EFileQueryType.explain]: "解释下面的内容",
  [EFileQueryType.rewrite]: "改写下面的内容",
  [EFileQueryType.expand]: "扩写下面的内容",
  [EFileQueryType.key_point]: "划线内容",
};

export const CONTENT_LANGS: IChatTransLang[] = [
  {
    title: "自动检测",
    default: true,
  },
  {
    title: "English",
    subTitle: "英语",
  },
  {
    title: "简体中文",
    subTitle: "简体中文",
  },
];

export const TARGET_LANGS: IChatTransLang[] = [
  {
    title: "简体中文",
    subTitle: "简体中文",
    default: true,
  },
  {
    title: "English",
    subTitle: "英语",
  },
];

export const DEFAULT_CONTENT_LANG = CONTENT_LANGS.find(item => item.default)!;

export const DEFAULT_TARGET_LANG = TARGET_LANGS.find(item => item.default)!;
